import { Component, OnInit } from '@angular/core';
import { ReportPageBase } from 'src/shared/Baseclasses/report-page-base';
import { Constants } from 'src/shared/utilities/constants.util';
import { ReportService } from 'src/shared/services/report.service';
import { ReportFilters } from 'src/shared/models/report-filters.model';
import { ReportConstants } from '../../shared/report-constants.util';
import { MiscUtil } from 'src/shared/utilities/misc.util';

@Component({
  selector: 'daily-churn-rate-page',
  templateUrl: './inpatient-churn-rate-page.component.html',
  styleUrls: ['./inpatient-churn-rate-page.component.scss']
})

export class InpatientChurnRatePageComponent extends ReportPageBase implements OnInit 
{
  defaultFilters: ReportFilters = new ReportFilters();
  views:string[];
  defaultView:string;

  constructor(private reportService: ReportService){
    super();
  }
  
  ngOnInit()
  {
    this.filters = this.defaultFilters;
    this.views = [
        ReportConstants.DateViewLabel,
        ReportConstants.DayOfWeekViewLabel,
        ReportConstants.PeriodEndViewLabel,
        ReportConstants.ShiftBlockViewLabel,
        ReportConstants.WeekViewLabel
    ];
    this.defaultView = ReportConstants.DateViewLabel;
    this.reportService.announceSummarySelected(Constants.NurseSummary);
  }

  filterUpdated(filters:ReportFilters){
    this.filters = filters;
    this.filterEventsSubject.next();
  }

  formatCellValue(value:number,decimalPlaces =2) {
     let val= MiscUtil.formatGridValue(value ,decimalPlaces);
     return  val != '-' ?`${val}%` :val ;
  }
}
